import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { Icon, iconTimeline } from '@ns/plugin-ns-theme';

import { rootRouteRef } from './routes';

// Note that these extensions aren't exported, only the plugin itself is.
// You can export it locally for testing purposes, but don't export it from the plugin package.
const NSDeveloperJourneyPage = PageBlueprint.make({
  // Extension id `page:ns-developer-journey/index` — the sidebar pins it by this id.
  name: 'index',
  params: {
    icon: <Icon glyph={iconTimeline} />,
    // Page extensions are always dynamically loaded using React.lazy().
    // All of the functionality of this page is implemented in the
    // NSDeveloperJourneyPage component, which is a regular React component.
    loader: () =>
      import('./components/ns-developer-journey-page').then(m => (
        <m.NSDeveloperJourneyPage />
      )),

    // This is the default path of this page, but integrators are free to override it
    path: '/journey',

    routeRef: rootRouteRef,

    // The title and icon are used to populate the app sidebar automatically
    title: 'Dev journeys guide',
  },
});

// The same plugin as above, now with the extensions added
export const nsDeveloperJourneyPlugin = createFrontendPlugin({
  extensions: [NSDeveloperJourneyPage],
  pluginId: 'ns-developer-journey',
  // We can also make routes available to other plugins.
  routes: {
    root: rootRouteRef,
  },
});
